import script from "./receiveAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./receiveAsset.vue?vue&type=script&setup=true&lang=js"

import "./receiveAsset.vue?vue&type=style&index=0&id=4b9aa812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9aa812"]])

export default __exports__